 <!-- Main Page Start -->
 <section class="skillsWrap">
  <div class="left-sidebar">
    <app-sidebar></app-sidebar>
  </div>
  <div class="right-panel">

      <form>
          <h4 class="pageTitle">Licenses / Certifications<a data-toggle="modal" data-target="#addModal" data-dismiss="modal" class="addMoreBtn" (click)="openModal(addMore)" tooltip="addMore"><i class="pluseIcon"><img src="assets/images/ic_plus.svg"> </i> Add More </a></h4>

          <div class="education_added">
              <ul class="timeline">
                  <li *ngFor="let data of allData; let i =index"> 
                      <span class="timeline-point-circle fill"></span>
                      <div class="el_details"> 
                          <p> <strong class="firstlCaptial">{{data.name|| ' N/A'}}</strong> 
                            <a href="javascript:void(0);" (click)="edit(data,addMore)" title="Edit"><img src="assets/images/ic_edit.svg" class="ht"> </a>
                            <a href="javascript:void(0);" (click)="delete(data.id)" title="Delete"><img src="assets/images/ic_delete.svg" class="ht"> </a>
                          </p> 
                          <span>{{data.attestedByAuthority|| ' N/A'}}</span>
                      </div>

                      <div class="el_details"> 
                          <ul>
                          <li><span class="ft-wt"> Issued on :</span> {{data.issuesedOn | date}} - {{data.expirydate != null ? (data.expirydate | date) : "(No expiration)"}} </li>
                          <li><span class="ft-wt">Certificate Id :</span> {{data.certificationNo || ' N/A'}}</li>
                          <li *ngIf="data.description != null"><span class="ft-wt">Description :</span>{{data.description || ' N/A'}}</li>
                          </ul>
                          <ul class="pt-2">
                              <li><span class="ft-wt">Certified URL</span>
                                  <a href="{{data.credentialUrl}}" target="_blank" class="blue-text">{{data.credentialUrl || ' N/A'}}</a>
                              </li>
                          </ul>
                      </div>
                  </li> 
              </ul>
          </div>

          <div class="form-group bottom ">
              <a href="javascript:void(0)" routerLink="/language" class="commonBtn width50 mt-5">Continue</a>
          </div>

      </form>
  </div>
</section>

<ng-template #addMore>
    <div class="modal-body">
        <button type="button" class="close" data-dismiss="modal" (click)="closeModal()">&times;</button>
        <form [formGroup]="form" (ngSubmit)="onSubmit()"> 
            <h4 class="pageTitle">{{title}} Licenses / certifications</h4>
            <div class="row">
                <div class="col-md-6 col-lg-6  col-sm-12">
                    <div class="form-group">
                        <label>Name<span class="orangeText">*</span> </label>
                        <input type="text"  class="form-control upper" placeholder="Behavioural economics" formControlName="name">
                        <div class="text-danger" *ngIf="form.controls['name'].hasError('required') && showError">
                            *Please enter name.
                        </div>
                    </div>
                </div>
                <div class="col-md-6 col-lg-6 col-sm-12">
                    <div class="form-group">
                        <label>Attested by authority <span class="orangeText">*</span> </label>
                        <input type="text"  class="form-control upper" placeholder="Ogilvy consulting USA" formControlName="attestedByAuthority">
                        <div class="text-danger" *ngIf="form.controls['attestedByAuthority'].hasError('required') && showError">
                            *Please enter Attested by Authority.
                        </div>
                    </div>
                </div>
                <div class="col-md-6 col-lg-6 col-sm-12 ">
                    <div class="form-group">
                        <label>ID/Certificate No.</label>
                        <input type="text"  class="form-control" placeholder="Certificate Id - 304304"  formControlName="certificationNo" maxlength="60">
                        <div class="text-danger" *ngIf="form.controls['certificationNo'].hasError('required') && showError">
                            *Please enter ID Certificate No.
                        </div>
                    </div>
                </div>
                <div class="col-md-6 col-lg-6 col-sm-12 ">
                    <div class=" d-flex justify-content-between">
                        <div class="form-group">
                            <label> Issue date</label>
                            <div id="date-picker-example" class="datepicker">
                              <input type="text" autocomplete="off" class="form-control" placeholder="Enter date" bsDatepicker placement="bottom" [bsValue]="form.value.issuesedOn" [bsConfig]="{ isAnimated: true, dateInputFormat: 'DD-MM-YYYY',showWeekNumbers: false,showTodayButton: true }" formControlName="issuesedOn" [maxDate]="maxDate" (bsValueChange)="onDateChange($event)" (keydown)="onKeyDown($event)">
                              <span class="ic_calendar"><img src="assets/images/ic_calendar.svg"></span>
                          </div>
                          <div class="text-danger" *ngIf="showError == true && form.controls['issuesedOn'].hasError('required')">*Please enter Issue date</div>
                        </div>
  
                        <div class="form-group">
                            <label>Expiry date (If any)</label>
                            <div id="date-picker-example" class="datepicker">
                              <input type="text" placeholder="Enter date"
                              class="form-control" bsDatepicker
                              [minDate]="form.value.issuesedOn == '' ? minDate : form.value.issuesedOn"
                              formControlName="expirydate" 
                              [minDate]="form.value.issuesedOn == '' ? minDate : form.value.issuesedOn"
                              [bsValue]="form.value.expirydate"
                              [bsConfig]="{ isAnimated: true, dateInputFormat: 'DD-MM-YYYY',showWeekNumbers: false,showTodayButton: true }" (keydown)="onKeyDown($event)">
                              <span class="ic_calendar"><img src="assets/images/ic_calendar.svg"></span>
                          </div>
                          <div class="text-danger" *ngIf="showError == true && form.controls['expirydate'].hasError('required')">*Please enter expiry date</div>
                        </div>
                    </div>
                </div>
                <div class="col-md-12 co-sm-12 col-lg-12 ">
                    <div class="form-group">
                        <label> Certified URL </label>
                        <input type="text"  class="form-control" placeholder="www.splashdesignstudio.com" formControlName="credentialUrl">
                        <div class="text-danger" *ngIf="form.controls['credentialUrl'].hasError('required') && showError">
                            *Please enter Certified URL.
                        </div>
                        <div class="text-danger" *ngIf="form.controls['credentialUrl'].hasError('pattern') && showError">
                            *Please enter Valid Certified URL with https or http.
                        </div>
                    </div>
                </div>
              </div>                
  
            <div class="form-group ">
              <input type="submit" value="Save" class="commonBtn width50 mt-2"> 
            </div>
      
        </form>
    </div>
</ng-template>
